import CabinetApi from '@/api-clients/cabinetApi/cabinet';
import { CdekStore } from '@/types/store';

export default (apiHost: string, apiPrefix: string, store: CdekStore) => ({
  cabinet: new CabinetApi(apiHost, apiPrefix, store),
});
